export const ROOT = "/admin/loyalty-program";